import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = 'G-JXJGS1D8NE';

export default function useAnalytics() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: pathname + search,
      page_location: window.location.href,
      send_to: GA_ID,
    });
  }, [pathname, search]);
}
